import { UriIssueReason } from './types';

/**
 * These are the error keyword types in JSON Schema that we want to filter out on draft entities when draft validation is enabled (tenant or entity level)
 * and no explicit filterOutErrorsByKeywords are provided in configuration.
 *
 * This is because these errors are typically not relevant to the author when they are still drafting their content.
 *  - "required" : not be helpful if the author has not yet had a chance to fill out all the required fields.
 *  - "minItems" : array keyword, want to allow drafting empty array types
 *  - "minProperties" : object keyword, want to allow drafting empty objects
 *  - "minContains": array keyword, used to validate that an array contains at least a minimum number of items that match a given schema.
 *  - "minLength": string keyword, during drafting an author might be in the process of writing and hasn't yet reached the required length.
 *
 * Read about these keywords here: https://json-schema.org/draft/2020-12/draft-bhutton-json-schema-validation-00#general
 */
export const draftErrorFilterKeywords = [
  'required',
  'allowEmpty',
  'minItems',
  'minProperties',
  'minContains',
  'minLength',
];

// Message map specific to URI-related issues
// Base (static) message catalogue. For dynamic details (e.g. which protocol) use getUriMessage.
export const URI_MESSAGES: Record<UriIssueReason, string> = {
  emptyHref: 'contains a link with an empty href',
  blockedProtocol: 'contains a link using a blocked protocol',
  invalidHref: 'contains a link with an invalid href',
};
